materials-index
  forms-materials-search(tag-scope="forms_materials_search")
  materials-table(tag-scope="materials_table")
  script(type="typescript").
    this.mixin('base');
